import React, { useEffect, useState } from 'react'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import Button from '../../../../atoms/Button/Button'
import { api } from '../../../../../utils/index'
import FormSelect from '../../../../atoms/FormSelect/FormSelect'
import useTrans from '../../../../../hooks/useTrans'
import { PROVINCE } from '../../../../../utils/endpoint'
import { trackingRegistrazioneFunnel } from '../../../../../utils/gtm'

const DatiAziendali = ({ step, setStep, props }) => {
  const [nazioni, setNazioni] = useState([])
  const [province, setProvince] = useState([])
  const t = useTrans()
  useEffect( () => {
    api.get('/nazioni/').then((result) => setNazioni(result.data))
    api.get(PROVINCE).then((result) => setProvince(result.data))
    !props.values.dati_aziendali?.email &&
      props.setFieldValue('dati_aziendali.email', props.values.utente.email)  
  }, [])

  const isDisabledForProvincia = (props) => {
    return props.values?.dati_aziendali?.withProvincia === true
      ? props.values?.dati_aziendali?.provincia !== null
        ? false
        : true
      : false
  }

  return (
    <div className="step-registrazione">
      <div className="step-registrazione__fieldsets">
        <FormField
          label={t('Ragione Sociale')}
          status={
            props.touched.dati_aziendali?.ragione_sociale &&
            props.errors.dati_aziendali?.ragione_sociale
              ? 'error'
              : props.touched.dati_aziendali?.ragione_sociale && 'success'
          }
          errorMessage={props.errors?.dati_aziendali?.ragione_sociale}
          id={"dati-aziendali-ragione-sociale"}
        >
          <FormInput
            value={props.values.dati_aziendali?.ragione_sociale}
            onChange={props.handleChange('dati_aziendali.ragione_sociale')}
            onBlur={props.handleBlur('dati_aziendali.ragione_sociale')}
            id={"dati-aziendali-ragione-sociale"}
          ></FormInput>
        </FormField>
        <FormField
          label={t('P.IVA')}
          status={
            props.touched.dati_aziendali?.partita_iva && props.errors.dati_aziendali?.partita_iva
              ? 'error'
              : props.touched.dati_aziendali?.partita_iva && 'success'
          }
          errorMessage={props.errors?.dati_aziendali?.partita_iva}
          id={"dati-aziendali-piva"}
        >
          <FormInput
            value={props.values.dati_aziendali?.partita_iva}
            onChange={props.handleChange('dati_aziendali.partita_iva')}
            onBlur={props.handleBlur('dati_aziendali.partita_iva')}
            id={"dati-aziendali-piva"}
          ></FormInput>
        </FormField>
        <FormField
          label={t('E-mail')}
          status={
            props.touched.dati_aziendali?.email && props.errors.dati_aziendali?.email
              ? 'error'
              : props.touched.dati_aziendali?.email && 'success'
          }
          errorMessage={props.errors?.dati_aziendali?.email}
          id={"dati-aziendali-email"}
        >
          <FormInput
            value={props.values.dati_aziendali?.email}
            onChange={props.handleChange('dati_aziendali.email')}
            onBlur={props.handleBlur('dati_aziendali.email')}
            id={"dati-aziendali-email"}
          ></FormInput>
        </FormField>
        <FormField
          label={t('telefono')}
          status={
            props.touched.dati_aziendali?.telefono && props.errors.dati_aziendali?.telefono
              ? 'error'
              : props.touched.dati_aziendali?.telefono && 'success'
          }
          errorMessage={props.errors?.dati_aziendali?.telefono}
          id={"dati-aziendali-telefono"}
        >
          <FormInput
            value={props.values.dati_aziendali?.telefono}
            onChange={props.handleChange('dati_aziendali.telefono')}
            onBlur={props.handleBlur('dati_aziendali.telefono')}
            id={"dati-aziendali-telefono"}
          ></FormInput>
        </FormField>
        <FormField
          label={t('indirizzo e n° civico')}
          status={
            props.touched.dati_aziendali?.indirizzo && props.errors.dati_aziendali?.indirizzo
              ? 'error'
              : props.touched.dati_aziendali?.indirizzo && 'success'
          }
          errorMessage={props.errors?.dati_aziendali?.indirizzo}
          id={"dati-aziendali-indirizzo"}
        >
          <FormInput
            value={props.values.dati_aziendali?.indirizzo}
            onChange={props.handleChange('dati_aziendali.indirizzo')}
            onBlur={props.handleBlur('dati_aziendali.indirizzo')}
            id={"dati-aziendali-indirizzo"}
          ></FormInput>
        </FormField>
        <FormField
          label={t('cap')}
          type="number"
          status={
            props.touched.dati_aziendali?.cap && props.errors.dati_aziendali?.cap
              ? 'error'
              : props.touched.dati_aziendali?.cap && 'success'
          }
          errorMessage={props.errors?.dati_aziendali?.cap}
          id={"dati-aziendali-cap"}
        >
          <FormInput
            value={props.values.dati_aziendali?.cap}
            onChange={props.handleChange('dati_aziendali.cap')}
            onBlur={props.handleBlur('dati_aziendali.cap')}
            id={"dati-aziendali-cap"}
          ></FormInput>
        </FormField>
        <FormField
          label={t('città')}
          status={
            props.touched.dati_aziendali?.citta && props.errors.dati_aziendali?.citta
              ? 'error'
              : props.touched.dati_aziendali?.citta && 'success'
          }
          errorMessage={props.errors?.dati_aziendali?.citta}
          id={"dati-aziendali-citta"}
        >
          <FormInput
            value={props.values.dati_aziendali?.citta}
            onChange={props.handleChange('dati_aziendali.citta')}
            onBlur={props.handleBlur('dati_aziendali.citta')}
            id={"dati-aziendali-citta"}
          ></FormInput>
        </FormField>

        <FormField
          label={t('paese')}
          status={
            props.touched.dati_aziendali?.nazione_id && props.errors.dati_aziendali?.nazione_id
              ? 'error'
              : props.touched.dati_aziendali?.nazione_id && 'success'
          }
          errorMessage={props.errors?.dati_aziendali?.nazione_id}
          id={"dati-aziendali-nazione"}
        >
          {/*INSERIRE LA SELECT NEL MOMENTO IN CUI SI AVRA L'API*/}
          <FormSelect
            isSearchable={true}
            placeholder={t('Seleziona Paese')}
            options={
              nazioni &&
              nazioni.map((nazione) => {
                return {
                  label: nazione.alias,
                  value: nazione.id,
                }
              })
            }
            value={props.values.dati_aziendali?.nazione_id}
            onChange={(e) => {
              props.setFieldValue(
                'dati_aziendali.withProvincia',
                e.target.label === 'Italia' ? true : false
              )

              props.setFieldValue('dati_aziendali.provincia', null)
              props.setFieldValue('dati_aziendali.nazione_id', e.target.value)
            }}
            onBlur={props.handleBlur('dati_aziendali.nazione_id')}
            id={"dati-aziendali-nazione"}
          ></FormSelect>
        </FormField>
        {props?.values?.dati_aziendali?.withProvincia && (
          <FormField
            label={t('Provincia')}
            status={
              props.values.dati_aziendali?.provincia === null
                ? 'error'
                : props.errors.dati_aziendali?.provincia
                ? 'error'
                : props.touched.dati_aziendali?.provincia && 'success'
            }
            errorMessage={
              props.values.dati_aziendali?.provincia === null
                ? t('Questo campo è obbligatorio')
                : props.errors?.dati_aziendali?.provincia
            }
            id={"dati-aziendali-provincia"}
          >
            <FormSelect
              onBlur={props.handleBlur('dati_aziendali.provincia')}
              isSearchable={true}
              onChange={(e) => {
                props.setFieldValue('dati_aziendali.provincia', e.target.value)
              }}
              placeholder={t('Provincia*')}
              value={props.values?.dati_aziendali?.provincia}
              options={province.map((p) => {
                return {
                  label: p.nome,
                  value: p.sigla,
                }
              })}
              id={"dati-aziendali-provincia"}
            ></FormSelect>
          </FormField>
        )}
      </div>

      <p className="step-registrazione__legend">*{t('Campi obbligatori')}</p>

      <Button
        disabled={props.errors.dati_aziendali || !props.dirty || isDisabledForProvincia(props)}
        variant="primary"
        label={t('Conferma dati')}
        size="medium"
        onClick={() => {
          trackingRegistrazioneFunnel(3)
          setStep(step + 1)
        }}
      />
    </div>
  )
}

export default DatiAziendali
